import React from 'react';

const RadioButtonIcon = props => {
  const { checked } = props;

  if (checked) {
    return (
      <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#xw7bw4cs8a)">
          <path d="M23 15a8 8 0 1 0-16 0 8 8 0 0 0 16 0z" fill="#fff" />
          <path d="M15 20.428a5.429 5.429 0 1 0 0-10.857 5.429 5.429 0 0 0 0 10.857z" fill="#007E83" />
          <path d="M22.714 15a7.714 7.714 0 1 0-15.428 0 7.714 7.714 0 0 0 15.428 0z" stroke="#007E83" />
        </g>
        <defs>
          <clipPath id="xw7bw4cs8a">
            <path fill="#fff" transform="translate(7 7)" d="M0 0h16v16H0z" />
          </clipPath>
        </defs>
      </svg>
    );
  }
  return (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#9mmtvlhrea)">
        <path d="M23 15a8 8 0 1 0-16 0 8 8 0 0 0 16 0z" fill="#fff" />
        <path d="M22.714 15a7.714 7.714 0 1 0-15.428 0 7.714 7.714 0 0 0 15.428 0z" stroke="#202020" strokeWidth=".607" />
      </g>
      <defs>
        <clipPath id="9mmtvlhrea">
          <path fill="#fff" transform="translate(7 7)" d="M0 0h16v16H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default RadioButtonIcon;
